import {Injectable} from '@angular/core';
import {ReadExportQuery} from '../model/export';
import {RestService} from "../../../services/rest.service";


@Injectable({
    providedIn: 'root'
})
export class ExportService {

    static readonly NodeShare = 'export/';


    constructor(private restService: RestService,
    ) {
    }

    async readAll(query: ReadExportQuery) {
        return (
            await this.restService.send<any>({
                url: ExportService.NodeShare + ReadExportQuery.createQueryURL(query),
                method: 'GET',
            })
        ).data;
    }


}
